module.exports = __webpack_public_path__ + "img/37.abb26c1a.jpg";